export default __webpack_public_path__ + "static/media/logo.ee07b915.svg";